import { IntlShape, useIntl } from "react-intl";

import { BulkExportType } from "@nens/ldo/api-v1";

export function bulkExportTypeDescription(intl: IntlShape, exportType: BulkExportType): string {
  if (exportType === "bulk_file") {
    return intl.formatMessage({
      id: "pages.export_scenarios",
      defaultMessage: "Export Scenarios",
    });
  }

  if (exportType === "composite_map") {
    return intl.formatMessage({
      id: "pages.export_composite",
      defaultMessage: "Export Composite Maps",
    });
  }
  if (exportType === "ror") {
    return intl.formatMessage({
      id: "pages.export_ror",
      defaultMessage: "Export ROR Maps",
    });
  }

  return "Unknown export";
}

export function BulkExportTypeDescription({ exportType }: { exportType: BulkExportType }) {
  const intl = useIntl();
  return <>{bulkExportTypeDescription(intl, exportType)}</>;
}
